/* ═════════════════════════════════════════════════════════════
   HYDRATED+ × SPORTCITY  ·  assets/hp-sportcity.js
   Native customer-form inschrijving + AJAX add-to-cart.
   Alles binnen een IIFE en gescoped op #scxRoot: geen globale namen,
   geen impact op de rest van het thema.
   ═════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('scxRoot');
    if (!root) return;

    function q(sel, ctx) { return (ctx || root).querySelector(sel); }
    function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

    var STORE_KEY = 'scx_signed_v1';
    var CODE = root.getAttribute('data-code') || '';

    /* ── Stap-weergave ── */
    var steps = {
      form: q('[data-scx-step="form"]'),
      success: q('[data-scx-step="success"]')
    };
    function showStep(name) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].hidden = (k !== name);
      });
    }

    var signed = false;
    try { signed = localStorage.getItem(STORE_KEY) === '1'; } catch (e) {}
    var justPosted = /[?&]sc_ok=1/.test(window.location.search);

    if (justPosted) {
      try { localStorage.setItem(STORE_KEY, '1'); } catch (e) {}
      /* param uit de URL halen zodat verversen niet blijft hangen */
      try { window.history.replaceState({}, '', window.location.pathname + window.location.hash); } catch (e) {}
    }

    if (signed || justPosted) { showStep('success'); }
    else { showStep('form'); }

    /* ── Formulier: validatie + veilige verzending ── */
    var form = document.getElementById('scxForm');
    var emailInput = q('[data-scx-email]');
    var errEl = q('[data-scx-error]');
    var submitBtn = q('[data-scx-submit]');
    var submitLabel = q('[data-scx-submit-label]');
    var returnInput = q('[data-scx-return]');
    var busy = false;

    function showErr(msg) {
      if (errEl) { errEl.textContent = msg; errEl.classList.add('is-visible'); }
      if (emailInput) emailInput.classList.add('is-invalid');
    }
    function clearErr() {
      if (errEl) errEl.classList.remove('is-visible');
      if (emailInput) emailInput.classList.remove('is-invalid');
    }
    if (emailInput) emailInput.addEventListener('input', clearErr);

    if (form) {
      form.addEventListener('submit', function (e) {
        if (busy) return; /* al bezig: laat een eventuele her-submit ongemoeid */
        e.preventDefault();
        var val = (emailInput && emailInput.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) {
          showErr('Vul een geldig e-mailadres in.');
          if (emailInput) emailInput.focus();
          return;
        }
        /* Geldig: koppel Shopify hCaptcha (verplicht sinds okt 2024) en verzend daarna. */
        busy = true;
        clearErr();
        if (returnInput) returnInput.value = window.location.pathname + '?sc_ok=1';
        if (submitBtn) submitBtn.classList.add('is-loading');
        if (submitLabel) submitLabel.textContent = 'Bezig met versturen...';
        function submitNow() { try { form.submit(); } catch (err) { HTMLFormElement.prototype.submit.call(form); } }
        try {
          if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
            window.Shopify.captcha.protect(form, submitNow);
          } else {
            submitNow();
          }
        } catch (err) { submitNow(); }
      });
    }

    /* ── Kortingscode kopieren ── */
    var copyBtn = q('[data-scx-copy]');
    var copyLabel = q('[data-scx-copy-label]');
    var copyOriginal = copyLabel ? copyLabel.textContent : 'Kopieer kortingscode';
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        function done() {
          copyBtn.classList.add('is-copied');
          if (copyLabel) copyLabel.textContent = 'Gekopieerd';
          window.setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            if (copyLabel) copyLabel.textContent = copyOriginal;
          }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(CODE).then(done).catch(fallback);
        } else { fallback(); }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = CODE; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    }

    /* ── Interne smooth-scroll knoppen (hero + succes) ── */
    qa('[data-scx-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var id = btn.getAttribute('data-scx-scroll');
        var target = id && document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var focusable = target.querySelector('input, button, a, select');
          if (id === 'scxSignup' && focusable) { window.setTimeout(function () { try { focusable.focus({ preventScroll: true }); } catch (er) {} }, 400); }
        }
      });
    });

    /* ── Toast ── */
    var toast = q('[data-scx-toast]');
    var toastText = q('[data-scx-toast-text]');
    var toastTimer = null;
    function showToast(msg) {
      if (!toast) return;
      if (toastText && msg) toastText.textContent = msg;
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(hideToast, 6000);
    }
    function hideToast() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      window.setTimeout(function () { toast.hidden = true; }, 360);
    }
    var toastClose = q('[data-scx-toast-close]');
    if (toastClose) toastClose.addEventListener('click', hideToast);

    /* ── Header-cartaantal + cart drawer bijwerken (best-effort, breekt nooit) ── */
    function refreshThemeCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;
          qa('[data-cart-count],.cart-count,.header__cart-count,[data-header-cart-count]', document).forEach(function (el) {
            el.textContent = count;
            el.hidden = false;
            el.removeAttribute('hidden');
          });
          /* Events die veelvoorkomende thema's oppikken om de drawer te verversen */
          ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (name) {
            try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
          });
        })
        .catch(function () {});
    }

    /* Probeer de theme cart drawer te openen (best-effort). Lukt dit niet, dan blijft de toast staan. */
    function tryOpenDrawer() {
      try {
        var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (!drawer) return false;
        if (typeof drawer.show === 'function') { drawer.show(); return true; }
        if (typeof drawer.open === 'function') { drawer.open(); return true; }
        var toggle = document.querySelector('[aria-controls="cart-drawer"],[data-cart-toggle],a[href$="/cart"] ');
        if (toggle && toggle.getAttribute('aria-controls')) { toggle.click(); return true; }
      } catch (e) {}
      return false;
    }

    /* ── Add to cart per productkaart ── */
    qa('.scx__prod').forEach(function (card) {
      var qtyInput = q('[data-scx-qty]', card);
      var minus = q('[data-scx-minus]', card);
      var plus = q('[data-scx-plus]', card);
      var variantEl = q('[data-scx-variant]', card);
      var atc = q('[data-scx-atc]', card);
      var atcLabel = q('[data-scx-atc-label]', card);

      function getQty() { var v = parseInt(qtyInput && qtyInput.value, 10); return (v && v > 0) ? v : 1; }
      function setQty(v) { if (qtyInput) qtyInput.value = v < 1 ? 1 : v; }
      if (minus) minus.addEventListener('click', function () { setQty(getQty() - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(getQty() + 1); });

      function variantId() {
        if (!variantEl) return null;
        return variantEl.tagName === 'SELECT' ? variantEl.value : variantEl.value;
      }

      var adding = false;
      if (atc) {
        atc.addEventListener('click', function () {
          if (adding || atc.disabled) return;
          var id = variantId();
          if (!id) { window.console && console.warn('[SCX] Geen variant-id gevonden.'); return; }
          adding = true;
          var original = atcLabel ? atcLabel.textContent : '';
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Toevoegen...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: getQty() }] })
          })
            .then(function (r) {
              if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Toevoegen mislukt'); });
              return r.json();
            })
            .then(function () {
              atc.classList.add('is-added');
              if (atcLabel) atcLabel.textContent = 'Toegevoegd';
              refreshThemeCart();
              var opened = tryOpenDrawer();
              if (!opened) showToast('Toegevoegd aan winkelwagen');
              window.setTimeout(function () {
                atc.classList.remove('is-added');
                if (atcLabel) atcLabel.textContent = original;
                atc.disabled = false;
                adding = false;
              }, 1800);
            })
            .catch(function (err) {
              adding = false;
              atc.disabled = false;
              if (atcLabel) atcLabel.textContent = original;
              window.console && console.warn('[SCX] Add-to-cart mislukt:', err);
              showToast('Er ging iets mis. Probeer het opnieuw.');
            });
        });
      }
    });
  });
})();
